<template>
  <v-ons-splitter>
    <v-ons-splitter-side collapse="(max-width: 650px)" swipable width="250px" :open.sync="showMenu">
      <menu-page @menu="onMenu"></menu-page>
    </v-ons-splitter-side>
    <v-ons-splitter-content id="content">
      <v-ons-page>
        <v-ons-toolbar>
          <div class="left">
            <v-ons-toolbar-button id="menu-button" @click="showMenu = !showMenu">
              <v-ons-icon icon="fa-bars"></v-ons-icon>
            </v-ons-toolbar-button>
          </div>
          <div class="center">{{ title }}</div>
          <div class="right" v-show="hasChanges">
            <v-ons-toolbar-button @click="saveChanges">
              <v-ons-icon icon="fa-save"/>
            </v-ons-toolbar-button>
          </div>
        </v-ons-toolbar>
        <slot></slot>
      </v-ons-page>
    </v-ons-splitter-content>
  </v-ons-splitter>
</template>

<script>

import MenuPage from "./MenuPage";
import util from "../util";

export default {
  name: "app-page",
  props: ['title'],
  components: { MenuPage },
  data: () => ({ showMenu: false }),
  methods: {
    onMenu(link) {
      if (link === "/logout") {
        localStorage.removeItem("credentials");
        this.$api.logout();
        this.$store.authenticated = false;
        this.$router.replace("/");
      } else {
        this.$router.push(link);
      } 
      this.showMenu = false;
    },
    async saveChanges() {
      try { 
        let added = this.$store.addedLabels.map(i => ({
          label: i.label,
          product: i.product,
          displayType: i.displayType
        }));
        let removed = this.$store.removedLabels.map(i => i.label);
        const result = await this.$api.sync({ added, removed });
        for (let i = 0; i < result.added.length; i++)
          added[i].error = result.added[i];
        for (let i = 0; i < result.removed.length; i++) {
          removed[i] = { 
            label: removed[i],
            error: result.removed[i]
          };
        }
        added = added.filter(item => item.error);
        removed = removed.filter(item => item.error);
        this.$store.addedLabels = added;
        this.$store.removedLabels = removed;
        if (added.length > 0 || removed.length > 0) {
          util.error(this, "There were errors with the pending operations", null);
        } else {
          util.info(this, `Added ${result.added.length} and removed ${result.removed.length} labels.`);
          util.sounds.success.play();
        }
      } catch(e) {
        util.error(this, "Saving changes failed", e);
      }
    }
  },
  computed: {
    hasChanges() {
      return this.$store.addedLabels.length > 0 
        || this.$store.removedLabels.length > 0;
    }
  }
};
</script>

<style scoped>
ons-splitter-side {
  width: 250px;
  border-right: 1px solid #BBB;
}
@media (max-width: 650px) {
  #content {
    left: 0px !important;
  }
  #menu-button {
    visibility: visible;
  }
}

@media (min-width: 650px) {
  #content {
    left: 250px !important;
  }
  #menu-button {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AppPage.vue